<template>
    <div class="row text-center pa-1 mt-n16">
        <v-container style="max-width: 1366px;">
            <v-layout class="mx-auto">
                <v-row cols="12" xs="12" class="text-left justify-center">
                    <v-col cols="12" offset="0" class="text-left pl-6 ma-0">
                        <h1
                            class="blue--text text--darken-5"
                            aria-label="Sekcja instytuty"
                        >
                            INSTYTUTY
                        </h1>
                    </v-col>
                </v-row>
            </v-layout>
            <v-lazy
                v-model="isActive"
                :options="{
                    threshold: 0.5
                }"
                min-height="200"
                transition="fade-transition"
            >
                <v-row class="text-center justify-center">
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <router-link
                            to="/student/instytut-przyrodniczo-techniczny/o-instytucie-ipt"
                        >
                            <v-progress-circular
                                :rotate="rotate"
                                :size="size"
                                :width="width"
                                :value="valueCircle1"
                                color="#0E3D85"
                            >
                                <v-img
                                    class="rounded-circle"
                                    :aspect-ratio="16 / 10"
                                    :width="imgsize"
                                    :height="imgsize"
                                    alt="Instytut Przyrodniczo-Techniczny"
                                    :src="
                                        '/images/' +
                                            'instytut-przyrodniczo-techniczny512x341.jpg'
                                    "
                                >
                                </v-img>
                            </v-progress-circular>
                        </router-link>
                        <h2>Instytut <br />Przyrodniczo-Techniczny</h2>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <v-progress-circular
                            :rotate="rotate"
                            :size="size"
                            :width="width"
                            :value="valueCircle2"
                            color="#C20444"
                        >
                            <router-link
                                to="/student/instytut-spoleczno-prawny/o-instytucie-isp"
                            >
                                <v-img
                                    class="rounded-circle"
                                    :aspect-ratio="16 / 10"
                                    :width="imgsize"
                                    :height="imgsize"
                                    :src="
                                        '/images/' +
                                            'instytut-spoleczno-prawny512x341.jpg'
                                    "
                                    alt="Instytut Społeczno-Prawny"
                                >
                                </v-img>
                            </router-link>
                        </v-progress-circular>
                        <h2>Instytut <br />Społeczno-Prawny</h2>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <v-progress-circular
                            :rotate="rotate"
                            :size="size"
                            :width="width"
                            :value="valueCircle3"
                            color="#0E3D85"
                        >
                            <router-link
                                to="/student/instytut-zdrowia/o-instytucie-iz"
                            >
                                <v-img
                                    class="rounded-circle"
                                    :aspect-ratio="16 / 10"
                                    :width="imgsize"
                                    :height="imgsize"
                                    :src="
                                        '/images/' +
                                            'instytut-zdrowia512x341.jpg'
                                    "
                                    alt="Instytut Zdrowia"
                                >
                                </v-img>
                            </router-link>
                        </v-progress-circular>
                        <h2>Instytut <br />Zdrowia</h2>
                    </v-col>
                </v-row>
            </v-lazy>
        </v-container>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

import searchvue from "./Search.vue";
import newsvue from "./pages/news.vue";

export default {
    components: {
        searchvue,
        newsvue
    },

    data() {
        return {
            isActive: false,
            interval: {},
            valueCircle1: 50,
            valueCircle2: 50,
            valueCircle3: 50,
            size: 300,
            imgsize: 280,
            width: 5,
            rotate: -40,
            circle: "0"
        };
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        mouseover: function(circle) {
            this.interval = setInterval(() => {
                if (circle == 1) {
                    if (this.valueCircle1 < 100) {
                        this.valueCircle1 += 10;
                    }
                    //return (this.valueCircle1 = 0);
                }
                if (circle == 2) {
                    if (this.valueCircle2 == 100) {
                        return (this.valueCircle2 = 0);
                    }
                    this.valueCircle2 += 10;
                }
                if (circle == 3) {
                    if (this.valueCircle3 == 100) {
                        return (this.valueCircle3 = 0);
                    }
                    this.valueCircle3 += 10;
                }
            }, 1000);
        },
        mouseleave: function() {
            clearInterval(this.interval);
            this.valueCircle1 = 50;
            this.valueCircle2 = 50;
            this.valueCircle3 = 50;
        }
    }
};
</script>

<style scoped>
.v-progress-circular {
    margin: 1rem;
}
</style>
